import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SideNavMenuComponent } from './side-nav-menu.component';
import { SideNavModule } from '@app/theme/side-nav/side-nav.module';
import { CurrentUserBoxModule } from '@app/theme/current-user-box/current-user-box.module';
import { SideNavHeaderComponent } from './side-nav-header/side-nav-header.component';
import { SideNavActionsComponent } from './side-nav-actions/side-nav-actions.component';
import { MaterialModule } from '@app/material/material.module';

@NgModule({
  declarations: [SideNavMenuComponent, SideNavHeaderComponent, SideNavActionsComponent],
  imports: [
    CommonModule,
    RouterModule,
    SideNavModule,
    CurrentUserBoxModule,
    MaterialModule,
  ],
  exports: [SideNavMenuComponent],
})
export class SideNavMenuModule {}
